var _path, _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgFlagCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 125,
    viewBox: "0 0 129 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4583 79.8334H93.7083C109.75 79.8334 116.167 73.4167 116.167 57.3751V38.1251C116.167 22.0834 109.75 15.6667 93.7083 15.6667H74.4583C58.4167 15.6667 52 22.0834 52 38.1251V57.3751C52 73.4167 58.4167 79.8334 74.4583 79.8334Z",
    fill: "url(#paint0_linear_2398_129995)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2398_129995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4583 94.4999H71.7083C87.75 94.4999 94.1667 88.0833 94.1667 72.0416V52.7916C94.1667 36.7499 87.75 30.3333 71.7083 30.3333H52.4583C36.4167 30.3333 30 36.7499 30 52.7916V72.0416C30 88.0833 36.4167 94.4999 52.4583 94.4999Z",
    fill: "url(#paint1_linear_2398_129995)",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2398_129995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4583 94.1667H71.7083C87.75 94.1667 94.1667 87.75 94.1667 71.7083V52.4583C94.1667 36.4167 87.75 30 71.7083 30H52.4583C36.4167 30 30 36.4167 30 52.4583V71.7083C30 87.75 36.4167 94.1667 52.4583 94.1667Z",
    fill: "url(#paint2_linear_2398_129995)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4583 94.1667H71.7083C87.75 94.1667 94.1667 87.75 94.1667 71.7083V52.4583C94.1667 36.4167 87.75 30 71.7083 30H52.4583C36.4167 30 30 36.4167 30 52.4583V71.7083C30 87.75 36.4167 94.1667 52.4583 94.1667Z",
    stroke: "url(#paint3_linear_2398_129995)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2398_129995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0063 49.0547C73.6183 48.7698 73.1967 48.7108 72.9536 48.6885C72.7151 48.6666 72.4294 48.6667 72.1601 48.6668L51.3396 48.6668C51.3375 48.6668 51.3354 48.6667 51.3333 48.6667C50.597 48.6667 50 49.2637 50 50.0001V74.0001C50 74.7365 50.597 75.3334 51.3333 75.3334C52.0697 75.3334 52.6667 74.7365 52.6667 74.0001L52.6667 64.6668L72.1601 64.6668C72.4294 64.6668 72.7151 64.6669 72.9536 64.645C73.1967 64.6227 73.6183 64.5637 74.0063 64.2788C74.4669 63.9406 74.7609 63.4214 74.8139 62.8524C74.8586 62.3732 74.6922 61.9812 74.5863 61.7613C74.4824 61.5456 74.3354 61.3007 74.1967 61.0698L71.5549 56.6668L74.1967 52.2638C74.3353 52.0329 74.4824 51.788 74.5863 51.5722C74.6922 51.3523 74.8586 50.9603 74.8139 50.4811C74.7609 49.9121 74.4669 49.3929 74.0063 49.0547Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2398_129995",
    x: 0,
    y: 0.333252,
    width: 124.166,
    height: 124.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_2398_129995"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2398_129995",
    x: 13.25,
    y: 13.25,
    width: 97.666,
    height: 97.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2398_129995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2398_129995",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2398_129995",
    x: 46,
    y: 46,
    width: 32,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2398_129995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2398_129995",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2398_129995",
    x1: 56.2984,
    y1: 63.7917,
    x2: 111.868,
    y2: 31.7084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2398_129995",
    x1: 34.2984,
    y1: 78.4583,
    x2: 89.8683,
    y2: 46.3749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2398_129995",
    x1: 34.2984,
    y1: 78.125,
    x2: 89.8683,
    y2: 46.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2398_129995",
    x1: 87.75,
    y1: 35.5,
    x2: 35.5,
    y2: 89.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFlagCategories);
export default __webpack_public_path__ + "static/media/img-flag-categories.b55e3084692af9787c5ed76f6def140c.svg";
export { ForwardRef as ReactComponent };